import {AddPaymentMethodController} from '@wc-stripe/controllers';
import {getPage, getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {LocalPaymentGateway} from '@wc-stripe/gateways';

const paymentMethods = getSetting('paymentMethods');

const context = new Context(getPage());

for (const [id, data] of Object.entries(paymentMethods)) {
    if (data.enabled && data.isLocal && data.supports?.includes('add_payment_method')) {
        const gateway = new LocalPaymentGateway({
            id,
            settings: getSetting(`${id}_data`),
            context
        });
        const controller = new AddPaymentMethodController({
            context,
            gateway,
            selector: `#wc_stripe_local_payment_${id}`
        });

        controller.initialize();
    }
}